module.exports = __webpack_public_path__ + "static/media/darksky.7021f77c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/darksky.png
// module id = 275
// module chunks = 0